/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The event pattern for the conversation message create event
 */

export const EventPattern = {
    SseSessionStart: 'event.sse.session.start',
    SseDistribute: 'event.sse.distribute',
    Ping: 'ping',
    EventReceived: 'event.received',
    ConversationCreate: 'chat.conversation.create',
    ConversationUpdate: 'chat.conversation.update',
    ConversationDelete: 'chat.conversation.delete',
    ConversationParticipantRemove: 'chat.conversation.participant.remove',
    ConversationRead: 'chat.conversation.read',
    ConversationUnread: 'chat.conversation.unread',
    ConversationPinned: 'chat.conversation.pinned',
    ConversationMuted: 'chat.conversation.mute',
    ConversationUnMuted: 'chat.conversation.unmute',
    ConversationMessageCreate: 'chat.conversation.message.create',
    ConversationMessageUpdate: 'chat.conversation.message.update',
    ConversationMessageDelete: 'chat.conversation.message.delete',
    ConversationMessageRead: 'chat.conversation.message.read',
    ConversationMessageReact: 'chat.conversation.message.react',
    ConversationMessageReactionCreate: 'chat.conversation.message.reaction.create',
    ConversationMessageReactionUpdate: 'chat.conversation.message.reaction.update',
    ConversationMessageReactionDelete: 'chat.conversation.message.reaction.delete',
    DeviceRegistrationEvent: 'event.device.create',
    DeviceLogout: 'event.device.logout',
    DrawLayerCreate: 'draw-layer.create',
    DrawLayerUpdateMetadata: 'draw-layer.update-metadata',
    DrawLayerDelete: 'draw-layer.delete',
    DrawFeatureUpdate: 'draw-feature.update',
    GlobalMuteChat: 'chat.global-mute',
    GroupCreate: 'nexus.group.create',
    GroupUpdate: 'nexus.group.update',
    GroupDelete: 'nexus.group.delete',
    OperationCreate: 'nexus.operation.create',
    OperationUpdate: 'nexus.operation.update',
    OperationNameUpdated: 'nexus.operation.name.updated',
    OperationUpdateMember: 'nexus.operation.update.member',
    OperationLocalRoleUpdated: 'nexus.operation.local.role.updated',
    OperationDefaultLayerUpdated: 'nexus.operation.layer.default.updated',
    OperationMemberRemove: 'nexus.operation.remove.member',
    OperationInviteSent: 'nexus.operation.invite.sent',
    OperationDelete: 'nexus.operation.delete',
    OperationVisibilityChanged: 'nexus.operation.visibility.changed',
    TrackerCreate: 'tracker.create',
    TrackerUpdate: 'tracker.update',
    TrackerDelete: 'tracker.delete',
    SymbolPackCreate: 'symbol.pack.create',
    SymbolPackUpdate: 'symbol.pack.update',
    SymbolPackDelete: 'symbol.pack.delete',
    AdoptChild: 'nexus.child.adopt',
    AbandonChild: 'nexus.child.abandon',
    ConsentCreate: 'consent.create',
    ConsentUpdate: 'consent.update',
    ConsentDelete: 'consent.delete',
    GeofenceAlarm: 'geofence.alarm',
    GeofenceCreate: 'geofence.create',
    GeofenceUpdate: 'geofence.update',
    GeofenceDelete: 'geofence.delete',
    GeofenceActivate: 'geofence.activate',
    GeofenceDeactivate: 'geofence.deactivate',
    NotificationCreate: 'notification.create',
    NotificationUpdate: 'notification.update',
    UserSettingsUpdate: 'user.settings.update',
    UserMapDisplaySettingsUpdate: 'user.map.settings.update',
    UserDetailsUpdate: 'user.details.update',
    UserClearLocation: 'user.clear.location',
} as const;

export type EventPattern = typeof EventPattern[keyof typeof EventPattern];



